module.exports = __webpack_public_path__ + "img/bg_content_header_02.64fd51a.png";